// 预览模块
export default {
    Preview: {
        ExitPreview: 'Tamat Pratonton',
        Tip: 'Tip：Ini laman pratonton, jawaban tidak akan direkodkan',
        MobilePhone: 'Telefon bimbit',
        Computer: 'Komputer',
        ReferenceThisTemplate: 'Petik templat ini',
        InReference: 'Sedang dipetik'
    },
  };